import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'EmployeePlan';

  static fields = {
    id: attr(),
    from: attr(),
    to: attr(),
    sort: attr({
      getDefault: () => 0,
    }),
    pointSystemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'employeePlans',
    }),
  };

  static reducer({ type, payload }, EmployeePlan) {
    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        EmployeePlan.all().delete();

        if (payload.employeePlans) {
          payload.employeePlans.forEach((employeePlan) => {
            EmployeePlan.upsert(employeePlan);
          });
        }

        break;
      case ActionTypes.CORE_INITIALIZE:
        if (payload.employeePlans) {
          payload.employeePlans.forEach((employeePlan) => {
            EmployeePlan.upsert(employeePlan);
          });
        }

        break;
      case ActionTypes.EMPLOYEE_PLANS_FETCH__SUCCESS: {
        const targetPointSystemId = String(payload.pointSystemId);
        EmployeePlan.all()
          .toRefArray()
          .filter((plan) => String(plan.pointSystemId) === targetPointSystemId)
          .forEach((plan) => {
            EmployeePlan.withId(plan.id)?.delete();
          });
        payload.items.forEach((item) => {
          EmployeePlan.upsert(item);
        });

        break;
      }
      case ActionTypes.EMPLOYEE_PLAN_CREATE__SUCCESS:
      case ActionTypes.EMPLOYEE_PLAN_UPDATE__SUCCESS:
        EmployeePlan.upsert(payload.item);

        break;
      case ActionTypes.EMPLOYEE_PLAN_DELETE__SUCCESS:
        EmployeePlan.withId(payload.item.id)?.delete();

        break;
      default:
    }
  }
}

